(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderTestDeleteController',PatientOrderTestDeleteController);

    PatientOrderTestDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatientOrderTest'];

    function PatientOrderTestDeleteController($uibModalInstance, entity, PatientOrderTest) {
        var vm = this;

        vm.patientOrderTest = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PatientOrderTest.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
